export interface Speaker {
  name: string;
  title: string; // z. B. Dr. med., Mag.
  specialty: string; // z. B. Urologie
  specialty_en?: string;
  photo_url?: string;
  bio?: string;
  bio_en?: string;
}

export const SPECIALTIES = ["Urologie", "Psychiatrie", "Allgemeinmedizin", "Mikrobiologie", "Psychotherapie", "Gastroenterologie", "Gynäkologie", "Innere Medizin", "Ernährungswissenschaft", "Pharmazie"];

export const CATERING_OPTIONS = [
  { key: "getraenke", de: "Getränke", en: "Drinks" },
  { key: "catering", de: "Catering", en: "Catering" },
  { key: "warme_speisen", de: "Warme Speisen", en: "Warm dishes" },
  { key: "kalte_speisen", de: "Kalte Speisen", en: "Cold dishes" },
  { key: "haeppchen", de: "Häppchen", en: "Finger food" },
] as const;

export const cateringLabel = (key: string, lang: string) => {
  const o = CATERING_OPTIONS.find((c) => c.key === key);
  return o ? (lang === "en" ? o.en : o.de) : key;
};

export interface EventRow {
  qa?: boolean | null;
  speakers: Speaker[] | null;
  id: string;
  slug: string;
  title: string;
  title_en: string | null;
  description: string;
  description_en: string | null;
  cover_image_url: string | null;
  location: string;
  starts_at: string | null;
  duration_minutes: number;
  price_eur: number;
  max_participants: number;
  published: boolean;
  registration_open: boolean;
  date_note: string | null;
  date_note_en: string | null;
  catering: string[] | null;
}

/** Nur Ankündigung: Anmeldung geschlossen oder noch kein fixes Datum */
export const isAnnouncement = (e: EventRow) => !e.registration_open || !e.starts_at;
export const evDateNote = (e: EventRow, lang: string) =>
  (lang === "en" && e.date_note_en) || e.date_note || (lang === "en" ? "Date to be announced" : "Termin folgt");

export const evTitle = (e: EventRow, lang: string) => (lang === "en" && e.title_en) || e.title;
export const evDesc = (e: EventRow, lang: string) => (lang === "en" && e.description_en) || e.description;

export const fmtDate = (iso: string, lang: string) =>
  new Date(iso).toLocaleDateString(lang === "en" ? "en-GB" : "de-AT", {
    timeZone: "Europe/Vienna", weekday: "long", day: "2-digit", month: "long", year: "numeric",
  });
export const fmtTime = (iso: string, lang: string) =>
  new Date(iso).toLocaleTimeString(lang === "en" ? "en-GB" : "de-AT", {
    timeZone: "Europe/Vienna", hour: "2-digit", minute: "2-digit",
  }) + (lang === "en" ? "" : " Uhr");
export const fmtPrice = (p: number, lang: string) =>
  Number(p) > 0 ? `${Number(p).toFixed(2).replace(".", lang === "en" ? "." : ",")} €` : lang === "en" ? "Free" : "Kostenlos";
